import { Component, Input } from '@angular/core'

export interface UserProfile {
  firstName: string
  lastName: string
  userProfileImage?: string
  [key: string]: any
}

@Component({
  selector: 'basin-user-avatar-group',
  templateUrl: './user-avatar-group.component.html',
  styleUrls: ['./user-avatar-group.component.scss'],
})
export class UserAvatarGroupComponent {
  @Input() users: UserProfile[] = []

  getUserNameString(firstName: string, lastName: string): string {
    return firstName + ' ' + lastName
  }

  getUserInitials(firstName: string, lastName: string): string {
    let firstInitial: string = Array.from(firstName)[0]
    let LastInitial: string = Array.from(lastName)[0]
    return firstInitial.toUpperCase() + LastInitial.toUpperCase() + ''
  }

  getAdditionalUserCount(numActiveUsers: number): string {
    const remainingNumUsers: number = numActiveUsers - 4
    return remainingNumUsers + '+'
  }
}
